import React,{lazy} from "react";
import { Navigate , useLocation} from "react-router-dom";
import { Route } from "react-router-dom";

import { isUserAuthenticated, getLoggedInUser } from "./helpers/authUtils";
import App from "./register/App";

// lazy load all the views
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const BridgerPayPage = React.lazy(() => import("./pages/BridgerPayPage"));

// auth
const Login = React.lazy(() => import("./pages/auth/Login"));

const Logout = React.lazy(() => import("./pages/auth/Logout"));
const ForgetPassword2 = React.lazy(() => import("./pages/auth/ForgetPassword"));
const TimeOutRequest = React.lazy(() => import("./pages/auth/TimeOutRequest"));
const ResetPassword = React.lazy(() => import("./pages/auth/ResetPassword"));
const Register = React.lazy(() => import("./pages/auth/Register"));
const Request = React.lazy(() => import("./pages/Request"));
const ChangePassword = React.lazy(() => import("./pages/auth/ChangePassword"));
const ConfirmAccount = React.lazy(() => import("./pages/auth/Confirm"));
const HomePage = React.lazy(() => import("./pages/HomePage"));
const SportsPage = React.lazy(() => import("./pages/SportsPage"));
const LeaguePage = React.lazy(() => import("./pages/LeaguePage"));
const MatchPage = React.lazy(() => import("./pages/MatchPage"));
const MyBets = React.lazy(() => import("./pages/MyBets"));
const FaqPage = React.lazy(() => import("./pages/FaqPage"));
const ContactusPage = React.lazy(() => import("./pages/ContactusPage"));
const InplayPage = React.lazy(() => import("./pages/InplayPage"));
const CasinoPage = React.lazy(() => import("./pages/CasinoPage"));
// const CasinoCategoriesPage = React.lazy(() => import("./pages/CasinoCategoriesPage"));
const GamePlay = React.lazy(() => import("./pages/GamePlay"));
const Game = React.lazy(() => import("./pages/Game"));
const LivePage = React.lazy(() => import("./pages/LivePage"));
// const PokerPage = React.lazy(() => import("./pages/PokerPage"));
const PromotionPage = React.lazy(() => import("./pages/PromotionPage"));

const Thankyou = React.lazy(() => import("./pages/Thankyou"));
const CmsDetail = React.lazy(() => import("./pages/CmsDetail"));

//const DailyLimit = React.lazy(() => import('./pages/DailyLimit'));
//const WageringLimit = React.lazy(() => import('./pages/WageringLimit'));
//const SelfExclusion = React.lazy(() => import('./pages/SelfExclusion'));
const UserKyc = React.lazy(() => import("./pages/UserKyc"));
const UserProfile = React.lazy(() => import("./pages/Userprofile"));
// const WithdrawRequests = React.lazy(() => import('./pages/WithdrawRequests'));
const KycUpdate = React.lazy(() => import("./pages/KycUpdate"));
const EditProfile = React.lazy(() => import("./pages/EditAccounts"));
const Wallet = React.lazy(() => import("./pages/Wallet"));
const WithdrawRequests = React.lazy(() => import("./pages/WithdrawRequests"));
const Leaderboard = React.lazy(() => import("./pages/Leaderboard"));
const GamePlayer = React.lazy(() => import("./pages/Gameplayer"));
const GamePlayerTeam = React.lazy(() => import("./pages/GamePlayerTeam"));
const ResponsibleGamblingPage = React.lazy(() =>
  import("./pages/ResponsibleGamblingPage")
);

// handle auth and authorization

// const PrivateRoute = ({ component: Component, roles, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) => {
//       const isAuthTokenValid = isUserAuthenticated();

//       if (!isAuthTokenValid) {
//         // not logged in so redirect to login page with the return url
//         return (
//           <Navigate
//             to={{ pathname: "/login", state: { from: props.location } }}
//           />
//         );
//       }

//       const loggedInUser = getLoggedInUser();
//       // check if route is restricted by role
//       if (roles && roles.indexOf(loggedInUser.role) === -1) {
//         console.log(roles);
//         // role not authorised so redirect to home page
//         //return <Redirect to={{ pathname: '/' }} />
//       }

//       // authorised so return component
//       return <Component {...props} />;
//     }}
//   />
// );


const PrivateRoute = ({ children }) => {
  const location = useLocation();
  if (!isUserAuthenticated()) {
    return <Navigate to="/?register" state={{ from: location }} replace />;
  }
  return children;
};

export default PrivateRoute;

const routes = [
  // auth and account

  // { path: "/?login", name: "Login", component: Login, route: Route },

  { path: "/logout", name: "Logout", component: Logout, route: PrivateRoute },
  {
    path: "/forget-password",
    name: "ForgetPassword2",
    component: ForgetPassword2,
    route: Route,
  },
  {
    path: "/time-out-request",
    name: "TimeOutRequest",
    component: TimeOutRequest,
    route: Route,
  },
  {
    path: "/reset-successfully",
    name: "ResetPassword",
    component: ResetPassword,
    route: Route,
  },
  { path: "/register", name: "Register", component: App, route: Route },

  {
    path: "/confirm",
    name: "Confirm",
    component: ConfirmAccount,
    route: Route,
  },

  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    route: PrivateRoute,
  },
  // other pages
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    route: PrivateRoute,
    roles: ["Admin"],
  },
  {
    path: "/BridgerPayPage",
    name: "BridgerPayPage",
    component: BridgerPayPage,
    route: Route,
  },
  
  { path: "/sports", name: "Sports", component: SportsPage, route: Route },
  { path: "/leagues", name: "Leagues", component: LeaguePage, route: Route },
  { path: "/match", name: "Match", component: MatchPage, route: Route },
  { path: "/my-bats", name: "MyBets", component: MyBets, route: PrivateRoute },
  { path: "/faq", name: "FaqPage", component: FaqPage, route: Route },
  {
    path: "/contactus",
    name: "ContactusPage",
    component: ContactusPage,
    route: Route,
  },
  { path: "/in-play", name: "InplayPage", component: InplayPage, route: Route },
  { path: "/casino", name: "CasinoPage", component: CasinoPage, route: Route },
  //  { path: "/user-profile:tab?", name: "Userprofile", component: UserProfile,route: Route },
  // { path: "/casino-categories", name: "CasinoCategoriesPage", component: CasinoCategoriesPage, route: Route },
  // {
  //   path: "/gameplay",
  //   name: "GamePlay",
  //   component: GamePlay,
  //   route: PrivateRoute,
  // },
 {
  path: "/user-profile/:tab?",
  name: "Userprofile",
  component: () => (
    <PrivateRoute>
      <UserProfile />
    </PrivateRoute>
  ),
  route: Route,
},

  {
    path: "/gameplay",
    name: "GamePlay",
    component: () => (
      <PrivateRoute>
        <GamePlay />
      </PrivateRoute>
    ),
    route: Route,
  },
  { path: "/game", name: "Game", component: Game, route: PrivateRoute },
  { path: "/livegame", name: "LivePage", component: LivePage, route: Route },
  // { path: "/pokergame", name: "PokerPage", component: PokerPage, route: Route },
  {
    path: "/promotion",
    name: "PromotionPage",
    component: PromotionPage,
    route: Route,
  },

  {
    path: "/responsible-gambling",
    name: "ResponsibleGamblingPage",
    component: ResponsibleGamblingPage,
    route: Route,
  },
  // STADIO PAGES
  { path: "/", exact: true, name: "Home", component: HomePage, route: Route },

  //{ path: '/daily_limit', name: 'Daily Limit', component: DailyLimit, route: PrivateRoute },
  //{ path: '/wagering_limit', name: 'Wagering Limit', component: WageringLimit, route: PrivateRoute },
  //{ path: '/self_exclusion', name: 'Self Exclusion', component: SelfExclusion, route: PrivateRoute },

  { path: "/user-kyc", name: "User kyc", component: UserKyc, route: Route },

  // { path: '/withdraw-requests', name: 'User profile', component: WithdrawRequests, route: PrivateRoute },
  {
    path: "/kyc-update",
    name: "User profile",
    component: KycUpdate,
    route: PrivateRoute,
  },
  {
    path: "/edit-profile",
    name: "Edit profile",
    component: EditProfile,
    route: PrivateRoute,
  },
  {
    path: "/withdraw-requests",
    name: "User profile",
    component: WithdrawRequests,
    route: PrivateRoute,
  },
  {
    path: "/add-amount",
    name: "Add Amount",
    component: Wallet,
    route: PrivateRoute,
  },
  {
    path: "/game-player",
    name: "game player",
    component: GamePlayer,
    route: PrivateRoute,
  },
  {
    path: "/game-player-team",
    name: "game player team",
    component: GamePlayerTeam,
    route: PrivateRoute,
  },
  {
    path: "/leaderboard",
    name: "Confirm",
    component: Leaderboard,
    route: Route,
  },
  {
    path: "/request",
    name: "Request",
    component: Request,
    route: PrivateRoute,
  },
  // {
  //     path: "/",
  //     exact: true,
  //     component: () => <Redirect to="/home" />,
  //     route: PrivateRoute
  // },

  { path: "/paymentsAcknowledge", name: "Thankyou", component: Thankyou, route: Route },

  { path: "/:slug", name: "CmsDetail", component: CmsDetail, route: Route },
];

export { routes, PrivateRoute };
